import { DA_TO_EN } from '@/components/en/EnLangSwitch';

// Resolve the existing automatic language choice before warming page bundles.
// Do not change history here: the router still performs the actual navigation.
export function getAutoLanguageTarget() {
  const path = window.location.pathname.replace(/\/$/, '').toLowerCase() || '/';
  const target = DA_TO_EN[path];
  if (!target || ['/zaptec-go', '/zaptec-go-2', '/nexblue-edge-2'].includes(path)) return null;
  const ua = navigator.userAgent || '';
  if (navigator.webdriver || /Lighthouse|HeadlessChrome|Googlebot|bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|PTST|GTmetrix/i.test(ua)) return null;
  try {
    if (localStorage.getItem('enkel_lang_pref') || sessionStorage.getItem('enkel_auto_lang_done')) return null;
  } catch { return null; }
  if (new URLSearchParams(window.location.search).get('lang')) return null;
  const primary = (navigator.languages?.[0] || navigator.language || '').toLowerCase().split('-')[0];
  if (!primary || ['da', 'nb', 'nn', 'no', 'sv', 'se', 'is', 'fo'].includes(primary)) return null;
  const hash = window.location.hash === '#aftaler' ? '#plans' : window.location.hash;
  return target + window.location.search + hash;
}
export const requestedEntryPath = window.location.pathname;
export const initialLanguageTarget = getAutoLanguageTarget();
export const effectiveEntryPath = (initialLanguageTarget || requestedEntryPath).split(/[?#]/)[0].toLowerCase().replace(/\/$/, '') || '/';